import React, { Component } from 'react';
import { connect }         from 'react-redux';

import { showMessageBox, isLoading }   from '../../actions';

import FileUploaderContainer from '../../components/Utilities/FileUploader';

class FileUploader extends Component {
  render() {
    return <FileUploaderContainer showMessageBox={this.props.showMessageBox} isLoading={this.props.isLoading} />;
  }
}

export default connect(s => s, {
  showMessageBox,
  isLoading,
})(FileUploader);



// WEBPACK FOOTER //
// ./src/containers/Utilities/FileUploader.js